import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, Calendar, Globe, Snowflake } from 'lucide-react';
import { useLanguage, LanguageSwitcher } from '@/components/LanguageContext';

const Article1 = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <div className="container mx-auto px-6 py-8">
        {/* Header */}
        <div className="mb-8">
          <Link to="/">
            <Button variant="outline" className="mb-4">
              <ArrowLeft className="h-4 w-4 mr-2" />
              {t('common.backToHome')}
            </Button>
          </Link>
          
          <div className="flex items-center mb-4">
            <Badge className="bg-blue-600 text-white mr-4">
              <Snowflake className="h-3 w-3 mr-1" />
              {t('category.weather')}
            </Badge>
            <span className="text-sm text-gray-600">Kuehne+Nagel</span>
          </div>
          
          <div className="flex items-center text-sm text-muted-foreground mb-6">
            <Calendar className="h-4 w-4 mr-1" />
            January 8, 2026
            <span className="mx-2">•</span>
            <span>5 min read</span>
          </div>
          
          <div className="flex justify-end mb-4">
            <LanguageSwitcher />
          </div>
        </div>

        {/* Article Content */}
        <article className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            {t('article.1.title')}
          </h1>
          
          <img 
            src="https://imgs.newseditor.aws.kuehne-nagel.cloud/6bd1b1b2-9b88-49f2-8b12-167579828f77.jpg"
            alt="Winter weather logistics disruption"
            className="w-full h-64 object-cover rounded-lg mb-8"
          />

          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-gray-700 mb-6 font-medium">
              {t('article.1.intro')}
            </p>

            <p className="mb-6">
              {t('article.1.detail1')}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">{t('article.1.section1.title')}</h2>
            
            <p className="mb-6">
              {t('article.1.section1.content')}
            </p>

            <p className="mb-6">
              {t('article.1.detail2')}
            </p>

            <p className="mb-6">
              {t('article.1.detail3')}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">{t('article.1.section2.title')}</h2>
            
            <p className="mb-6">
              {t('article.1.section2.content')}
            </p>

            <p className="mb-6">
              {t('article.1.detail4')}
            </p>

            <p className="mb-6">
              {t('article.1.detail5')}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">{t('article.1.section3.title')}</h2>
            
            <p className="mb-6">
              {t('article.1.section3.content')}
            </p>

            <p className="mb-6">
              {t('article.1.detail6')}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">{t('article.1.section4.title')}</h2>
            
            <p className="mb-6">
              {t('article.1.section4.content')}
            </p>

            <div className="bg-blue-50 p-6 rounded-lg mt-8">
              <p className="text-sm text-gray-700">
                <strong>{t('article.1.detail7')}</strong>
              </p>
            </div>
          </div>

          {/* Source Attribution */}
          <div className="mt-12 p-6 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600 mb-2">
              {t('common.sourceAttribution')} Kuehne+Nagel official newsletter.
            </p>
            <p className="text-sm text-gray-600 mb-4">
              {t('common.sourceDetails')}
            </p>
            <a 
              href="https://mykn.kuehne-nagel.com/news/article/severe-winter-weather-continues-to-disrupt" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block"
            >
              <Button className="bg-blue-600 hover:bg-blue-700 text-white">
                {t('common.readOriginalArticle')}
              </Button>
            </a>
          </div>

          {/* Navigation */}
          <div className="mt-8 flex justify-between">
            <Link to="/">
              <Button variant="outline">
                <ArrowLeft className="h-4 w-4 mr-2" />
                {t('common.backToAllArticles')}
              </Button>
            </Link>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Article1;